import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import imagen1 from './assets/Med_No-01.jpg'
import './DiaCirugia.css'
import '@fontsource/fira-sans';
import '@fontsource/fira-sans/700.css';
import '@fontsource/fira-sans/500.css';
import '@fontsource/fira-sans/400-italic.css';
import '@fontsource/fira-sans/200.css';
import Dia01Img from "./assets/Dia01.jpg";
import Dia02Img from "./assets/Dia02.jpg";
import Dia03Img from "./assets/Dia03.jpg";
import Dia04Img from "./assets/Dia04.jpg";
import Dia05Img from "./assets/Dia05.jpg";

function DiaCirugia() {
    const navigate = useNavigate();

    const handleAnterior = () => {
      navigate('/indicaciones/previas');
      window.scrollTo(0, 0);
    };
  
    const handleSiguiente = () => {
      navigate('/indicaciones/recuperacion');
      window.scrollTo(0, 0);
    };
    
    
    return (
      
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1 className="titlePreguntas_dia">El día de tu cirugía</h1>
            <br></br>
            <div className="container_dia"> 
                <div id="card_1_dia"> 
                    
                    <h1> AYUNO</h1>
                     
                    <p className="p_1_dia">Contar con <b>8 horas de ayuno </b>, ya que cualquier líquido o sólido que ingrese a tu estómago puede provocar vómito y bajo anestesia este contenido alimenticio puede irse a los pulmones, provocando problemas como neumonitis o neumonía. Si el estómago se encuentra vacío el riesgo es nulo. 

                    </p>
              
                </div>
                <img src={Dia01Img} id="image_1" alt="Imagen revision" className='img-DiaCirugia'/>
            <hr className='separador_dia'></hr>

            <img src={Dia02Img} id="image_2" alt="Imagen evaluación" className='img-DiaCirugia'></img>
                <div id="card_2_dia">
                    <h1> EVALUACIÓN POR <br></br> TU ANASTESIÓLOGO </h1>
                    <p>Tendrás una entrevista con tu anestesiólogo quien te hará muchas preguntas y te explicará el tipo de procedimiento anestésico adecuado a ti y al procedimiento quirúrgico.  
                    </p>
                </div>
                <hr className='separador_dia'></hr>

                
                
                <div id="card_1_dia">
                    <h1>NOTIFICAR ALERGIAS</h1>
                    <p>Existen varios tipos de reacciones alérgicas, desde un simple rash hasta choque anafiláctico, es importante hacernos saber si has tenido algún tipo de reacción.
                    </p>
                </div>
                <img src={Dia03Img} id="image_3" alt="Imagen anestesia" className='img-DiaCirugia'></img>
               
                <hr className='separador_dia'></hr>
                <img src={Dia04Img} id="image_4" alt="Imagen Cirugia" className='img-DiaCirugia' ></img>
                <div id="card_2_dia">
                    <h1>PROBLEMAS CON <br></br>LA ANESTESIA</h1>
                    <p>Sí tu o algún familiar directo ha tenido problemas con la anestesia, infórmanos, eso nos ayudará a resolver tus dudas y tomar las precauciones necesarias.
                    </p>
                </div>
              
                <hr className='separador_dia'></hr>

               


                <div id="card_1_dia">
                    <h1> ASEO</h1>
                    <p className="si_dia">Lo que <b>SÍ</b> se permite:
                        Tomar un baño, lavar los dientes y aplicar desodorante (excepto si tu cirugía abarca esa zona).
                    </p>
                    <p className="no_dia">Lo que <b>NO</b> se permite:
                        Aplicarte cualquier tipo de crema, loción, maquillaje, esmalte de uñas / gelish.
                    </p>
                </div>
                <img src={Dia05Img} id="image_5" alt="Imagen recuperacion" className='img-DiaCirugia'></img>
                
                
            </div>
        {/* BOTONES */}
        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '30px', marginBottom: '30px' }}>
          <button className="nav-button-dia" onClick={handleAnterior}>Anterior</button>
          <button className="nav-button-dia" onClick={handleSiguiente}>Siguiente</button>
        </div>




        </div>);

}

export default DiaCirugia;
